<template>
    <!-- Página -->
    <div
        v-if="layout === 'page'"
        class="container-fluid text-left page-card admin-weflix-editPlan d-flex flex-column flex-grow-1"
        data-aos="fade-left"
        data-aos-duration="1500"
    >
        <div class="d-flex flex-column flex-grow-1">
            <template v-if="!hideHeading">
                <h1 class="card-title mb-2">Editar Plano</h1>
                <p class="card-subtitle mb-4 mb-md-0">
                    Escolha um nome e uma periodicidade de renovação de assinatura
                    para este plano.
                </p>
                <hr class="page-card__divider mb-md-6" />
            </template>

            <div class="row" v-if="hasReady">
                <div class="col-12 col-md-6 m-0 mb-3">
                    <div>
                        <label class="labeld"
                            >Nome do Plano<v-tooltip
                                text="Campo obrigatório"
                                location="top"
                            >
                                <template v-slot:activator="{ props }">
                                    <fa
                                        v-bind="props"
                                        icon="fa-solid fa-circle-exclamation"
                                    ></fa>
                                </template> </v-tooltip
                        ></label>
                    </div>
                    <div class="form-input">
                        <input
                            type="text"
                            required
                            class="inputd mb-1"
                            v-model="nomePlano"
                            placeholder="Plano Mensal - 2º Semestre"
                        />
                    </div>
                </div>

                <div class="col-12 col-md-6 m-0 mb-3">
                    <div>
                        <label class="labeld" :for="idPrefix + '-valor'"
                            >Valor<v-tooltip
                                text="Campo obrigatório"
                                location="top"
                            >
                                <template v-slot:activator="{ props }">
                                    <fa
                                        v-bind="props"
                                        icon="fa-solid fa-circle-exclamation"
                                    ></fa>
                                </template> </v-tooltip
                        ></label>
                    </div>
                    <div class="form-input">
                        <input
                            :id="idPrefix + '-valor'"
                            type="text"
                            required
                            class="inputd mb-1"
                            v-model="valorPlano"
                            placeholder="R$ 99,99"
                        />
                    </div>
                </div>

                <div class="col-12 col-md-6 m-0 mb-3">
                    <div>
                        <label class="labeld"
                            >Frequência de Renovação<v-tooltip
                                text="Campo obrigatório"
                                location="top"
                            >
                                <template v-slot:activator="{ props }">
                                    <fa
                                        v-bind="props"
                                        icon="fa-solid fa-circle-exclamation"
                                    ></fa>
                                </template> </v-tooltip
                        ></label>
                    </div>
                    <div class="form-input">
                        <select
                            required
                            class="inputd mb-1"
                            v-model="frequenciaRenovacao"
                        >
                            <option value="" disabled>Selecione a frequência</option>
                            <option value="1">Mensal</option>
                            <option value="2">Semestral</option>
                            <option value="3">Trimestral</option>
                            <option value="4">Anual</option>
                        </select>
                        <small>Escolha a frequência de renovação do plano.</small>
                    </div>
                </div>

                <div class="col-12 col-md-6 m-0 mb-3">
                    <div>
                        <label class="labeld"
                            >Definir como recomendado<v-tooltip
                                text="Campo obrigatório"
                                location="top"
                            >
                                <template v-slot:activator="{ props }">
                                    <fa
                                        v-bind="props"
                                        icon="fa-solid fa-circle-exclamation"
                                    ></fa>
                                </template> </v-tooltip
                        ></label>
                    </div>
                    <div
                        class="form-input"
                        style="display: flex; flex-wrap: wrap; gap: 10px"
                    >
                        <CustomToggle v-model="recomendado" />
                        <small
                            >Um plano recomendado é tratado como principal na
                            tela de pagamento. Ative como recomendado e o Plano
                            terá mais destaque.</small
                        >
                    </div>
                </div>
            </div>
        </div>

        <div
            class="d-flex align-items-center justify-content-center justify-content-md-end ga-3 mt-5 mt-md-7"
        >
            <v-btn
                variant="outlined"
                color="primary"
                :size="$vuetify.display.xs ? 'default' : 'large'"
                :disabled="!hasReady || saving"
                @click="onCancel"
            >
                Voltar
            </v-btn>
            <v-btn
                variant="flat"
                color="primary"
                :size="$vuetify.display.xs ? 'default' : 'large'"
                :loading="saving"
                :disabled="!hasReady || saving"
                @click="submitEdit"
                >Salvar</v-btn
            >
        </div>
        <Loader :hasReady="hasReady" />
    </div>

    <!-- Modal -->
    <div v-else class="edit-plan-form edit-plan-form--modal text-left">
        <Loader :hasReady="hasReady" />
        <div v-if="hasReady" class="d-flex flex-column flex-grow-1">
            <div class="row plan-form-fields">
                <div class="col-12 col-md-6 m-0 mb-3">
                    <div>
                        <label class="labeld"
                            >Nome do Plano<v-tooltip
                                text="Campo obrigatório"
                                location="top"
                            >
                                <template v-slot:activator="{ props }">
                                    <fa
                                        v-bind="props"
                                        icon="fa-solid fa-circle-exclamation"
                                    ></fa>
                                </template> </v-tooltip
                        ></label>
                    </div>
                    <div class="form-input">
                        <input
                            type="text"
                            required
                            class="inputd mb-1"
                            v-model="nomePlano"
                            placeholder="Plano Mensal - 2º Semestre"
                        />
                    </div>
                </div>

                <div class="col-12 col-md-6 m-0 mb-3">
                    <div>
                        <label class="labeld" :for="idPrefix + '-valor'"
                            >Valor<v-tooltip
                                text="Campo obrigatório"
                                location="top"
                            >
                                <template v-slot:activator="{ props }">
                                    <fa
                                        v-bind="props"
                                        icon="fa-solid fa-circle-exclamation"
                                    ></fa>
                                </template> </v-tooltip
                        ></label>
                    </div>
                    <div class="form-input">
                        <input
                            :id="idPrefix + '-valor'"
                            type="text"
                            required
                            class="inputd mb-1"
                            v-model="valorPlano"
                            placeholder="R$ 99,99"
                        />
                    </div>
                </div>

                <div class="col-12 col-md-6 m-0 mb-3">
                    <div>
                        <label class="labeld"
                            >Frequência de Renovação<v-tooltip
                                text="Campo obrigatório"
                                location="top"
                            >
                                <template v-slot:activator="{ props }">
                                    <fa
                                        v-bind="props"
                                        icon="fa-solid fa-circle-exclamation"
                                    ></fa>
                                </template> </v-tooltip
                        ></label>
                    </div>
                    <div class="form-input">
                        <select
                            required
                            class="inputd mb-1"
                            v-model="frequenciaRenovacao"
                        >
                            <option value="" disabled>Selecione a frequência</option>
                            <option value="1">Mensal</option>
                            <option value="2">Semestral</option>
                            <option value="3">Trimestral</option>
                            <option value="4">Anual</option>
                        </select>
                        <small>Escolha a frequência de renovação do plano.</small>
                    </div>
                </div>

                <div class="col-12 col-md-6 m-0 mb-3">
                    <div>
                        <label class="labeld"
                            >Definir como recomendado<v-tooltip
                                text="Campo obrigatório"
                                location="top"
                            >
                                <template v-slot:activator="{ props }">
                                    <fa
                                        v-bind="props"
                                        icon="fa-solid fa-circle-exclamation"
                                    ></fa>
                                </template> </v-tooltip
                        ></label>
                    </div>
                    <div
                        class="form-input"
                        style="display: flex; flex-wrap: wrap; gap: 10px; align-items: center"
                    >
                        <CustomToggle v-model="recomendado" />
                        <small
                            >Um plano recomendado é tratado como principal na
                            tela de pagamento. Ative como recomendado e o Plano
                            terá mais destaque.</small
                        >
                    </div>
                </div>
            </div>
        </div>

        <div
            v-if="hasReady"
            class="plan-modal__footer"
        >
            <v-btn
                variant="flat"
                class="plan-modal__button plan-modal__button--cancel"
                :disabled="saving"
                @click="onCancel"
            >
                Cancelar
            </v-btn>
            <v-btn
                variant="flat"
                class="plan-modal__button plan-modal__button--save"
                :loading="saving"
                :disabled="saving"
                @click="submitEdit"
            >
                Salvar Alterações
            </v-btn>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import { toast } from 'vue3-toastify';
    import Plans from '@/utils/Weflix/plan';
    import Loader from '@/components/Weflix/Loader.vue';
    import CustomToggle from '@/components/Form/CustomToggle.vue';

    export default {
        name: 'EditPlanForm',
        components: {
            Loader,
            CustomToggle,
        },
        emits: ['success', 'cancel', 'saving-change'],
        props: {
            planId: {
                type: String,
                default: '',
            },
            layout: {
                type: String,
                default: 'page',
                validator: (v) => ['page', 'modal'].includes(v),
            },
            hideHeading: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                nomePlano: '',
                valorPlano: '',
                frequenciaRenovacao: '',
                recomendado: false,
                habilitarBoleto: false,
                habilitarPix: false,
                discount: 0,
                hasReady: false,
                saving: false,
            };
        },
        computed: {
            ...mapState(['token']),
            idPrefix() {
                return this.layout === 'modal' ? 'modal-edit-plan' : 'page-edit-plan';
            },
        },
        watch: {
            planId: {
                immediate: true,
                handler(id) {
                    if (id) this.loadPlan();
                },
            },
            saving(val) {
                this.$emit('saving-change', val);
            },
        },
        methods: {
            async loadPlan() {
                if (!this.planId) return;
                this.hasReady = false;
                try {
                    const response = await Plans.getPlanById(this.token, this.planId);
                    this.nomePlano = response.name;
                    this.valorPlano = response.planValue;
                    this.frequenciaRenovacao =
                        response.planType != null ? String(response.planType) : '';
                    this.recomendado = response.recommended == 1;
                    this.habilitarBoleto = response.billet == 1;
                    this.habilitarPix = response.pix == 1;
                    this.discount = Number(response.discount) || 0;
                    this.hasReady = true;
                } catch (error) {
                    console.error(error);
                    this.notify('Erro ao carregar o plano.', 'error');
                    this.hasReady = true;
                }
            },
            onCancel() {
                this.$emit('cancel');
            },
            async submitEdit() {
                if (!this.planId) return;
                const payload = {
                    name: this.nomePlano,
                    planValue: parseFloat(this.valorPlano),
                    planType: Number(this.frequenciaRenovacao),
                    recommended: this.recomendado ? 1 : 0,
                    card: 1,
                    billet: this.habilitarBoleto ? 1 : 0,
                    pix: this.habilitarPix ? 1 : 0,
                    discount: Number(this.discount) || 0,
                    status: 1,
                };
                this.saving = true;
                try {
                    await Plans.editPlan(payload, this.token, this.planId);
                    this.$emit('success');
                } catch (error) {
                    this.notify(
                        'Erro ao editar plano. Verifique os dados e tente novamente.',
                        'error'
                    );
                    console.error(error);
                } finally {
                    this.saving = false;
                }
            },
            notify(message, type = 'info') {
                toast(message, {
                    autoClose: 3000,
                    position: 'top-right',
                    theme: 'light',
                    limit: 1,
                    type: type,
                    dangerouslyHTMLString: true,
                });
            },
        },
    };
</script>

<style scoped>
    @import '@/Views/Weflix/Adm/global.css';

    .admin-weflix-editPlan {
        height: 100%;
        position: relative;
    }

    .edit-plan-form--modal {
        min-height: 120px;
        position: relative;
    }

    .creditCard {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        text-align: left;
        gap: 21px;
    }

    .infoCreditCard h4 {
        margin: 0;
        font-size: 16px;
        font-weight: 700;
    }

    .infoCreditCard {
        width: 80%;
    }

    .infoCreditCard p {
        margin: 0;
        color: gray;
    }

    .form-control:disabled {
        cursor: not-allowed;
        background-color: #f0f0f0;
    }

    @media (max-width: 600px) {
        .admin-weflix-editPlan h3 {
            font-size: 20px;
            margin-bottom: 5px;
        }

        .admin-weflix-editPlan small {
            font-size: 12px;
            color: #666;
        }
    }
</style>
